import { render, staticRenderFns } from "./IconHouseRising.vue?vue&type=template&id=2189807e&"
import script from "./IconHouseRising.vue?vue&type=script&lang=ts&"
export * from "./IconHouseRising.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports